import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "pdf-render top-0 left-0 h-screen bg-white overflow-y-auto"
};
import html2canvas from 'html2canvas';
import { ref, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'PDFRender',
  setup(__props, {
    expose: __expose
  }) {
    const contentRef = ref();
    const show = ref(false);
    const renderPDF = async (html, name = 'report.pdf') => {
      show.value = true;
      await nextTick();
      console.time('html2canvas');
      // 1. 填充内容并获取页面内容的总高度
      contentRef.value.innerHTML = html;
      await nextTick();
      // 获取页面内容的总高度
      const {
        scrollHeight
      } = contentRef.value;
      // 清空容器内容准备分页
      contentRef.value.innerHTML = '';
      // 2. 创建 Paged.js 分页预览器
      const paged = new window.Paged.Previewer();
      const maxH = Math.max(1440, scrollHeight / 5);
      // contentRef.value.style.cssText = `--pdf-height: ${maxH - 96}px`
      // 进行分页处理
      const flow = await paged.preview(html, [], contentRef.value);
      console.log('分页完成', flow);
      // 3. 获取所有分页后的页面
      const pages = Array.from(contentRef.value.querySelectorAll('.pagedjs_pagebox'));
      if (pages.length) {
        const {
          default: JsPDF
        } = await import('jspdf');
        const pdf = new JsPDF({
          orientation: 'portrait',
          unit: 'px' // 使用像素为单位
        });
        // 设置PDF页面标准尺寸（A4）
        const pdfPageWidth = contentRef.value.clientWidth;
        // 渲染每一页
        for (let i = 0; i < pages.length; i += 1) {
          const page = pages[i];
          // 使用 html2canvas 渲染每页内容为画布
          // eslint-disable-next-line no-await-in-loop
          const canvas = await html2canvas(page, {
            useCORS: true,
            scale: 1.5 // 使用较高的缩放比例提高清晰度
          });
          // 获取每页的宽高（canvas大小）
          const scale = pdfPageWidth / canvas.width;
          const pageWidth = pdfPageWidth;
          const pageHeight = canvas.height * scale;
          // 如果是第一页之后的页面，添加新页面
          if (i > 0) {
            pdf.addPage(); // 添加新页面
          }
          // 动态设置 PDF 页面尺寸，确保每一页的大小与渲染的图像一致
          pdf.internal.pageSize.width = pageWidth;
          pdf.internal.pageSize.height = pageHeight;
          // 将渲染的图像添加到 PDF 页面
          pdf.addImage(canvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, pageWidth, pageHeight);
        }
        console.timeEnd('html2canvas');
        // 保存 PDF 文件
        pdf.save(name);
      }
      show.value = false; // 完成后隐藏渲染区域
    };
    __expose({
      renderPDF
    });
    return (_ctx, _cache) => {
      return show.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        ref_key: "contentRef",
        ref: contentRef,
        class: "cus-md-minimalist card-content beautify"
      }, null, 512)])])) : _createCommentVNode("", true);
    };
  }
});